export const environment = {
    production: false,
    services: {
        'ang-lieb-service': {
            uri: 'https://service.liebink.dev/',
            token: true,
        }
    },
};
